import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const faqs = [
  { q: 'How long does it take to see results?', a: 'Most clients see measurable improvements within 2-3 months.' },
  { q: 'Do you offer custom packages?', a: 'Yes, we tailor our services to your business needs and goals.' },
  { q: 'Can you manage our social media accounts?', a: 'Absolutely! We offer full-service social media management.' },
];

const FAQ = () => (
  <section className="min-h-screen bg-[#0f1a29] py-20 px-4 flex flex-col items-center justify-center">
    <div className="max-w-3xl w-full bg-white rounded-2xl shadow-2xl p-10 relative z-10">
      <motion.h1
        className="text-4xl font-bold text-brand-blue mb-6 text-center"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        Frequently Asked Questions
      </motion.h1>
      <div className="space-y-8">
        {faqs.map((f, i) => (
          <motion.div
            key={i}
            className="bg-blue-50 rounded-lg p-6 shadow mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: i * 0.2, ease: 'easeOut' }}
          >
            <h2 className="text-xl font-bold text-brand-blue mb-2">{f.q}</h2>
            <p className="text-gray-800">{f.a}</p>
          </motion.div>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold text-center">Back to Home</Link>
        <Link to="#contact" onClick={e => { e.preventDefault(); const section = document.getElementById('contact'); if (section) section.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-blue-100 text-brand-blue rounded-lg shadow hover:bg-blue-200 transition font-semibold text-center">Contact Us</Link>
      </div>
    </div>
  </section>
);

export default FAQ; 